export default function SurseFinanciarePage() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-xl font-bold mt-8 mb-4">Bugetul</h2>
        <h2 className="text-xl font-bold mt-8 mb-4">Bilanțul contabil</h2>
      </main>
    </div>
  );
}
